module.exports = __webpack_public_path__ + "static/media/go.22eda6c5.svg";